import { render, staticRenderFns } from "./notes-customer.vue?vue&type=template&id=491ace70&scoped=true&"
import script from "./notes-customer.vue?vue&type=script&lang=js&"
export * from "./notes-customer.vue?vue&type=script&lang=js&"
import style0 from "./notes-customer.vue?vue&type=style&index=0&id=491ace70&scoped=true&lang=css&"
import style1 from "./notes-customer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491ace70",
  null
  
)

export default component.exports